import gql from 'graphql-tag';

export default gql`
  fragment FlowParameterFilePointerFields on Flow_Parameter_File_Pointer {
    __typename
    variable
    field
  }
`;
